import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';

import { Flex } from 'Components/Base';

const ArrowButton = styled((props) => <Flex {...props} />)`
  ${({ theme, isShown, isInfinite, isNext, arrowTopOffset }) => {
    const { colors, fontSizes } = theme;
    return css`
      justify-content: center;
      align-items: center;
      width: 32px;
      height: 32px;
      color: ${colors.primaryDark};
      background: rgba(0, 0, 0, 0.5);
      display: ${!isShown && !isInfinite ? 'none !important' : 'flex !important'};
      outline: none;
      font-size: ${fontSizes[5]}px;
      border-radius: 50%;
      border-color: ${colors.primaryDark};
      position: absolute;
      left: ${isNext ? 'unset' : '12px'};
      right: ${isNext ? '12px' : 'unset'};
      top: ${`calc(20% - ${arrowTopOffset}px)`};
      z-index: 1;
      border-style: none;
      transition: all 400ms;
      cursor: pointer;
      color: white;
      &:hover {
        background-color: ${colors.greyscale.grey1};
        color: white;
      }
    `;
  }}
`;

const CarouselArrow = ({ isNext, isShown, isInfinite, arrowTopOffset, ...props }) => (
  <ArrowButton
    isNext={isNext}
    isShown={isShown}
    isInfinite={isInfinite}
    arrowTopOffset={arrowTopOffset}
    {...props}
  >
    {isNext ? <KeyboardArrowRight fontSize="large" /> : <KeyboardArrowLeft fontSize="large" />}
  </ArrowButton>
);

CarouselArrow.propTypes = {
  isNext: PropTypes.bool,
  isShown: PropTypes.bool,
  isInfinite: PropTypes.bool,
  arrowTopOffset: PropTypes.number,
};

CarouselArrow.defaultProps = {
  isNext: true,
  isShown: true,
  isInfinite: false,
};

export default CarouselArrow;
